import { getAccessTokenforResource } from 'owa-tokenprovider';
import { trace } from 'owa-trace';
import { parse as parseUrl } from 'url';

const TEAMS_ONLY_HEADER = 'X-MS-TeamsOnly';

export default async function makeSkypeApiCallViaFetch<T>(
    method: 'GET' | 'POST',
    resource: string,
    endpoint: string,
    postData?: any
) {
    if (!resource) {
        return Promise.resolve<T>(null);
    }
    const url = parseUrl(resource);
    const resourceUrl = `${url.protocol}//${url.host}/`;
    const token = await getAccessTokenforResource(resourceUrl);
    if (!token) {
        return undefined;
    }
    const request = {
        method: method,
        headers: getSkypeApiHeaders(token),
        body: postData ? JSON.stringify(postData) : undefined,
    };

    try {
        const fetchResponse = await fetch(endpoint, request);
        const response: T = await fetchResponse.json();
        const teamsOnlyHeaderSet =
            !!fetchResponse.headers.get(TEAMS_ONLY_HEADER) &&
            fetchResponse.headers.get(TEAMS_ONLY_HEADER) == 'true';
        return {
            ...response,
            teamsOnlyHeaderSet,
        };
    } catch (e) {
        trace.warn('Error calling Skype API: ' + e.message);
        return undefined;
    }
}

function getSkypeApiHeaders(token: string) {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Ms-Namespace': 'internal',
        'X-Ms-SDK-Host': 'Exchange',
        Authorization: 'Bearer ' + token,
    };
}

export function buildPolicyRequestUrl(baseUri: string, endpoint: string) {
    const url = parseUrl(baseUri);
    return `${url.protocol}//${url.host}${endpoint}`;
}
